import { giphyBlack, giphyIndigo, giphyLightGrey } from '@giphy/colors'
import { useContext } from 'react'
import UserContext from 'shared/contexts/user'
import styled from 'styled-components'
import { PillBlock } from '../../blocks'
import { ICapture, IPending } from '../shared/types'
import { CompletedCaptureList, PendingCaptureList } from './capture-list'

const Placeholder = styled.div`
    margin-top: 30px;
    height: 400px;
    background-image: url('/static/img/supercut/placeholder-capture-table.svg');
    position: relative;

    &:after {
        content: '';
        background: linear-gradient(0deg, ${giphyBlack} 0%, rgba(0, 0, 0, 0) 100%);
        position: absolute;
        height: 100px;
        right: 0;
        bottom: 0;
        left: 0;
    }
`

const Heading = styled.div`
    letter-spacing: 0.26px;
    font-weight: bold;
    margin-top: 30px;
    margin-bottom: 15px;
`

const NotificationInfo = styled.span`
    float: right;
    color: ${giphyLightGrey};
    font-style: italic;
    font-size: 13px;
`

const Pill = styled(PillBlock)`
    background: ${giphyIndigo};
    margin-left: 5px;
`

type Props = {
    captures: ICapture[]
    pending: IPending[]
    isAllCaptures: boolean
    onCaptureDeleted?: (id: string) => void
}

const CaptureTable = ({ captures, pending, isAllCaptures, onCaptureDeleted = () => {} }: Props) => {
    const { user } = useContext(UserContext)

    if (captures.length === 0 && pending.length === 0) {
        return <Placeholder />
    } else {
        return (
            <div>
                {pending.length > 0 && (
                    <Heading>
                        Pending Captures <Pill>{pending.length >= 10 ? '10+' : pending.length}</Pill>
                        <NotificationInfo>
                            {
                                "If you've enabled Browser Notifications, you'll receive an update when processing is completed."
                            }
                        </NotificationInfo>
                    </Heading>
                )}

                <PendingCaptureList captures={pending} />

                {captures.length > 0 && (
                    <Heading>
                        Captures <Pill>{captures.length >= 50 ? '50+' : captures.length}</Pill>
                    </Heading>
                )}

                <CompletedCaptureList
                    captures={captures}
                    showUsername={user.isStaff && isAllCaptures}
                    onCaptureDeleted={onCaptureDeleted}
                />
            </div>
        )
    }
}

export default CaptureTable
